import { render, staticRenderFns } from "./Buscador.vue?vue&type=template&id=2bf00151&scoped=true&"
import script from "./Buscador.vue?vue&type=script&lang=ts&"
export * from "./Buscador.vue?vue&type=script&lang=ts&"
import style0 from "./Buscador.vue?vue&type=style&index=0&id=2bf00151&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf00151",
  null
  
)

export default component.exports